module.exports = __webpack_public_path__ + "img/Twitter_Social_Icon_Rounded_Square_Color.9fd9b71b.png";